import { SearchBar } from "antd-mobile";
import type { SearchBarProps, SearchBarRef } from "antd-mobile";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { ReactNode, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { setPageSearch } from "../../../redux/PageSearch/pageSearch.slice";

interface IProps extends SearchBarProps {
  leftIcon: ReactNode;
  headingText?: string;
}

export const LocalSearchBar: FC<IProps> = ({ leftIcon, headingText }) => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const searchRef = useRef<SearchBarRef>(null);

  // Define pages that should use local search
  const localSearchPages = {
    "/clinical": "clinical" as const,
    "/watchlist": "watchlist" as const,
    "/bedexits": "bedexits" as const,
    "/my-facility": "myFacility" as const,
    "/motion-and-exits": "motionAndExits" as const,
  };

  // Get search value from Redux for current page
  const currentPageKey =
    localSearchPages[location.pathname as keyof typeof localSearchPages];
  const pageSearchStates = useAppSelector((state) => state.pageSearch);
  const currentSearchValue = currentPageKey
    ? pageSearchStates[currentPageKey]
    : "";

  const handleChange = (value: string) => {
    if (currentPageKey) {
      dispatch(setPageSearch({ page: currentPageKey, value }));
    }
  };

  useEffect(() => {
    if (location.pathname === "/search") searchRef.current?.focus();
  });

  return (
    <div className={styles.container}>
      {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}
      <SearchBar
        ref={searchRef}
        placeholder="Search by Patient Name or Room"
        data-test-id="local-search"
        clearable
        value={currentSearchValue}
        className={classNames(styles.localSearchBar, {
          [styles.searchBarWithoutIcon]: !leftIcon,
        })}
        onChange={handleChange}
      />
      {headingText && (
        <h5 className={styles.heading} id="main-heading">
          {headingText}
        </h5>
      )}
    </div>
  );
};
